import React from 'react';
import { Waypoint } from 'react-waypoint';
var OffsetTracking = function (_a) {
    var onOffsetReached = _a.onOffsetReached, rowIdx = _a.rowIdx, children = _a.children;
    if (!onOffsetReached) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(Waypoint, { fireOnRapidScroll: false, bottomOffset: '90%', onEnter: function () { return onOffsetReached(rowIdx); } }, children));
};
OffsetTracking.displayName = 'OffsetTracking';
export default OffsetTracking;
//# sourceMappingURL=OffsetTracking.js.map